import useSwr, { SWRResponse } from "swr";
import { getCecEligibility } from "services/cecEligibility";

interface PpcRequiredResponse extends SWRResponse<boolean> {
  loading: boolean;
  isPpcRequired: boolean | undefined;
}

const usePpcRequired = ({
  lookupId,
  enabled,
}: {
  lookupId?: string;
  enabled: boolean;
}): PpcRequiredResponse => {
  const shouldFetch = enabled && Boolean(lookupId);
  const result = useSwr(
    shouldFetch ? ["cec-eligibility", lookupId] : null,
    async ([, id]: [string, string]) => getCecEligibility(id),
    {
      shouldRetryOnError: false,
    }
  );

  return {
    ...result,
    loading: result.isLoading || result.isValidating,
    isPpcRequired: result.data,
  };
};

export { usePpcRequired };
